import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Components
import { ErrorDialogComponent } from '@app/error-dialog/error-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ErrorDialogService {
    constructor(
        private dialog: MatDialog
    ) { }

    public onErrorDialog(errorMsg: Array<string>, isEditFailure: boolean = false, titleText: string = null, btnText: string = null) {
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: '100%',
            maxWidth: '782px',
            height: 'auto',
            panelClass: ['ie11-center','material-modal-container'],
            data: {
                errorMsg,
                isEditFailure,
                titleText,
                btnText
            }
        });
        dialogRef.afterClosed().subscribe();
        return dialogRef;
    }
}
